import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; 
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBTMiBgqxNpGcEWgZo7bzizyDywLFgz508",
  authDomain: "revival-church-f2637.firebaseapp.com",
  projectId: "revival-church-f2637",
  storageBucket: "revival-church-f2637.appspot.com",
  messagingSenderId: "795337865984",
  appId: "1:795337865984:web:c9e2a3bf356412d89011e5"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage();

export { db, storage };